module.exports = __webpack_public_path__ + "img/mat_11.58efc3ca.png";